import create from "zustand";

const useStore = create(set => ({
    playerTeleport : {
        position : undefined,
        teleportState : false,
        distance : undefined,
        teleportTo : (newPosition, newDistance) => set(state => {
            state.playerTeleport.position = newPosition
            state.playerTeleport.distance = newDistance
        }),
        setTeleport : (teleState) => set(state => (state.playerTeleport.teleportState = teleState))
    },

    touchController : {
        movementState : {
            forward : false,
            backward : false,
            left : false,
            right : false
        },
        movement : (key) => set(state => {
            state.touchController.movementState[key] = true
            state.touchController.buttonsActive = true
        }),
        breakMovement : (key) => set(state => {
            state.touchController.movementState[key] = false
            setTimeout(() => {state.touchController.buttonsActive = false}, 200)
        }),
        buttonsActive : false
    },

    propogateToStall : {
        position : undefined,
        rotation : undefined,
        propogateState : false,
        currentHotspot : undefined,
        exitButton : false,
        propogateTo : (newPosition, newRotation) => set(state => {
            state.propogateToStall.position = newPosition
            state.propogateToStall.rotation = newRotation
        }),
        setPlayerState : (propState, btnState) => set(state => {
            state.propogateToStall.propogateState = propState
            state.propogateToStall.exitButton = btnState
        }),
        setHotspot : (hotspot) => set(state => {
            state.propogateToStall.currentHotspot = hotspot
        })
    },

    videoDisplay : {
        position : undefined,
        rotation : undefined,
        triggerVideo : (newPosition, newRotation) => set(state => {
            state.videoDisplay.position = newPosition
            state.videoDisplay.rotation = newRotation
        })
    },

    stallPosition : {
        stallsData :undefined,
        stallNav : false,
        setData : (data) => set(state => {
            state.stallPosition.stallsData = data
        }),
        setNav : (stall) => set(state => {
            if(JSON.stringify(state.stallPosition.stallNav) !== JSON.stringify(stall)){
                state.stallPosition.stallNav = stall
            }
        })
    },

    pan : {
        panEnable : false,
        setPan : (panState) => set(state => state.pan.panEnable = panState)
    }
  }))


  export default useStore